import { useState } from "react";

export default function useSortData() {
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "asc",
  });

  const sortData = (items, checkedItems = {}) => {
    if (!sortConfig.key) return items;

    return [...items].sort((a, b) => {

       let valueA;
      let valueB;

      // ✅ CHECKBOX SORT
      if (sortConfig.key === "checkbox") {
        const aChecked = checkedItems[a.leave_id] ? 1 : 0;
        const bChecked = checkedItems[b.leave_id] ? 1 : 0;

        return sortConfig.direction === "asc"
          ? bChecked - aChecked   // ✔ checked first
          : aChecked - bChecked; // ✔ unchecked first
      }
       // ✅ ACTION SORT (Dept)
    else if (sortConfig.key === "action_sort") {
     valueA = a.floor_status === 2 && a.dpt_status === 1 ? 1 : 0;
     valueB = b.floor_status === 2 && b.dpt_status === 1 ? 1 : 0;
    }
     else if (sortConfig.key === "action_sort1") {
        valueA = a.floor_status === 1 ? 1 : 0;
        valueB = b.floor_status === 1 ? 1 : 0;
      }
      // ✅ ACTION SORT (HR)
      else if (sortConfig.key === "action_sort_hr") {
        valueA =
          a.floor_status == 2 &&
          a.dept_status == 2 &&
          a.hrs_status == 1
            ? 1
            : 0;

        valueB =
          b.floor_status == 2 &&
          b.dept_status == 2 &&
          b.hrs_status == 1
            ? 1
            : 0;
      }
    else
    {
      // ✅ NORMAL SORT
      valueA = a[sortConfig.key] ?? "";
      valueB = b[sortConfig.key] ?? "";
    }
      

      if (valueA < valueB) return sortConfig.direction === "asc" ? -1 : 1;
      if (valueA > valueB) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });
  };

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  return { sortConfig, sortData, handleSort };
}
